import apiClient from "../base/apiClient";
import { AssignCitiesRequest, Voucher, VoucherUpdateRequest } from "./types";

export const promotionApi = {
  getVouchers: async (params: { 
    filter?: string; 
    page?: number; 
    count?: number 
  }) => {
    const { filter = '', page = 0, count = 100 } = params;
    
    const response = await apiClient.get(`/Administration/Voucher/ListAll`, {
      params: { 
        filter, 
        page, 
        count 
      },
      withCredentials: true,
    });
    
    if (response.data.errorMessage) {
      throw new Error(response.data.errorMessage);
    }
    if (response.data.error) {
      throw new Error(response.data.error);
    }
    
    const vouchers = response.data.vouchers || [];
    return {
      data: vouchers.map((voucher: Voucher) => ({
        ...voucher,
      })),
      total: response.data.total || vouchers.length,
    };
  },

  updateVoucher: async (voucherData: VoucherUpdateRequest) => {
    const response = await apiClient.put(`/Administration/Voucher/Update`, voucherData, {
      withCredentials: true,
    });
    
    if (response.data.errorMessage) {
      throw new Error(response.data.errorMessage);
    }
    
    return response.data;
  },

  assignCities: async (assignData: AssignCitiesRequest) => {
    const response = await apiClient.post(`/Administration/Voucher/AssignCities`, assignData, {
      withCredentials: true,
    });
    
    if (response.data.errorMessage) {
      throw new Error(response.data.errorMessage);
    }
    
    return response.data;
  },

  createVoucher: async (voucherData: {
    code: string;
    type: number;
    amount: number;
    cap: number;
    limit: number;
    isActive: boolean;
  }) => {
    try {
      const response = await apiClient.post(`/Administration/Voucher/Create`, voucherData, {
        withCredentials: true,
      });
      
      if (response.data.errorMessage) {
        throw new Error(response.data.errorMessage);
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteVoucher: async (id: number) => {
    try {
      const response = await apiClient.delete(`/Administration/Voucher/Delete`, {
        params: { id },
        withCredentials: true,
      });
      
      if (response.data.errorMessage) {
        throw new Error(response.data.errorMessage);
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};